import React from "react";
import './AboutUs.css';
import logo from "../../assets/images/schmodelplain-withR-white.png";
import header from "../../assets/images/beauty-is-our-business-model.png";
import LogoDropDown from "../LogoDropDown/logoDropDown";

function AboutUsCom() {
    return (
        <div className="about-us-container">
            <div className='about-us-header'>
                <LogoDropDown activeItems={["Schmodel"]}/>
            </div>
            <div className="about-us-main">
                <img
                    src={header} className="" alt="header"
                    style={{
                        width: '47%',
                        marginBottom: '40px',
                    }}
                />
                Powered by fashion and beauty icons.<br/>
                <br/>
                Our private community of brands and <br/>
                creatives breaks down the barriers of <br/>
                luxury fashion to deliver a truly <br/>
                unique shopping experience.<br/>
                <br/>
                Creator inspired circular luxury<br/>
                is at the heart of our mission.<br/>
                <br/>
                Coming AW2026

            </div>
            <div
                className="about-us-footer"
            >
                <img
                    src={logo} className="" alt="logo"
                    style={{
                        width: '33.5%'
                    }}
                />
            </div>
        </div>
    );
}

export default AboutUsCom;
